<template>
    <div />
</template>

<script>
    export default {
        name: 'Base',
        props: ['event', 'eventChanged', 'unit'],
        data () {
            return {
                edit: false,
                compareOptions: [
                    {value: 'gt', text: 'message.greater_then'},
                    {value: 'eq', text: 'message.equals'},
                    {value: 'lt', text: 'message.less_then'}
                ],
                translate: {
                    'gt': 'message.greater_then',
                    'eq': 'message.equals',
                    'lt': 'message.less_then'
                },
                hourOptions: [
                    {value: '0:00', text: '0:00'},
                    {value: '1:00', text: '1:00'},
                    {value: '2:00', text: '2:00'},
                    {value: '3:00', text: '3:00'},
                    {value: '4:00', text: '4:00'},
                    {value: '5:00', text: '5:00'},
                    {value: '6:00', text: '6:00'},
                    {value: '7:00', text: '7:00'},
                    {value: '8:00', text: '8:00'},
                    {value: '9:00', text: '9:00'},
                    {value: '10:00', text: '10:00'},
                    {value: '11:00', text: '11:00'},
                    {value: '12:00', text: '12:00'},
                    {value: '13:00', text: '13:00'},
                    {value: '14:00', text: '14:00'},
                    {value: '15:00', text: '15:00'},
                    {value: '16:00', text: '16:00'},
                    {value: '17:00', text: '17:00'},
                    {value: '18:00', text: '18:00'},
                    {value: '19:00', text: '19:00'},
                    {value: '20:00', text: '20:00'},
                    {value: '21:00', text: '21:00'},
                    {value: '22:00', text: '22:00'},
                    {value: '23:00', text: '23:00'},
                    {value: '24:00', text: '24:00'}
                ]
            }
        },
        methods: {
            remove () {
                this.eventChanged('marked_to_delete', this.event)
                // if (this.event.id == null && this.event.saved === false) {
                //     this.eventChanged('marked_to_delete', this.event)
                // }
            },
            save () {
                this.edit = false
                this.eventChanged('marked_to_save', this.event)
            }
        },
        created () {
            this.edit = this.event.id == null || this.event.saved === false
        }
    }
</script>

<style scoped>

</style>
